import { createReduxData, handleHMR } from 'irmlib/virtusa-redux'

/*
  This module gives you the ability to trigger the running of functions in react screens, which do not give access to their functions.
  Now, this can also be done with CustomEvents but they are somewhat clumsy. However, you are also give the ability to trigger
  a render of some react screen from other screens or even from business code.

  So, the combination of the two gives complete control of react components from the outside.

  To use the listener pattern do:
    1) id = addObserver('testKey', reactFunction) in the componentDidMount/hook equivalent
    2) removeObserver(id) in the componentWillUnmount/hook equivalent
    3) To trigger the reactFunction call, triggerObserver('testKey', someData), then reactFunction(someData) will be called.

  To use the component render pattern do:
    1) useSelector(() => getObserverValue('testKey')) or mapStateToProps equivalent
    2) To trigger the component render, triggerObserver('testKey') and the component will re-render.
*/

// Put observer keys here.
export const observerTest = 'observerTest'

const traceObserver = (process.env.NODE_ENV !== 'production') && false
let listenerId = 0
const listeners = []
const reducerKey = 'observer'

const initialState = {

}

let { setState, getState } = handleHMR(module, initialState)
/**
 * initObserver sets up the redux machinery for observers.
 * 
 * @param {object} store - Redux store
 * @returns {void} Nothing
 */
export function initObserver(store) {
  ({ setState, getState } = createReduxData(store, reducerKey, initialState))
}

export const addObserver = (observerKey, listener) => {
  const id = listenerId++
  if (traceObserver) {
    // eslint-disable-next-line no-console
    console.log(`observer id=${id} key=${observerKey}, value at key=${getState()[observerKey]}`)
  }
  listeners.push({
    id,
    listener,
    observerKey
  })
  return id
}

// Put this in componentWillUnmpount
export const removeObserver = id => {
  if (traceObserver) {
    // eslint-disable-next-line no-console
    console.log(`removeObserver id=${id}`)
  }
  const index = listeners.findIndex(e =>
    id === e.id
  )
  if (index !== -1) {
    listeners.splice(index, 1)
  }
}
  
export const triggerObserver = (observerKey, data) => {
  if (traceObserver) {
    // eslint-disable-next-line no-console
    console.log(`triggerObserver key=${observerKey}`)
  }
  // Change the value at the observerKey. This will allow any consumers using
  // mapStateToProps on observerKey to re-render.
  let observerKeyState = getState()[observerKey]
  if (observerKeyState === undefined) {
    observerKeyState = 0
  } else {
    observerKeyState++
  }
  setState({ [observerKey]: observerKeyState })

  // Next run the listener function for any observer on observerKey.
  for (let i = 0; i < listeners.length; ++i) {
    if (listeners[i].listener && listeners[i].observerKey === observerKey) {
      listeners[i].listener(data)
    }
  }
}

// Use this for useSelector (hooks).
export const getObserverValue = observerKey =>
  getState()[observerKey]
  

